/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ZpZXdzL2NhdGVnb3JpYS1zZXJ2aWNvL3N1Yi1jYXRlZ29yaWEvc3ViLWNhdGVnb3JpYS1saXN0L2NvcGlhci1zdWItbW9kYWwvY29waWFyLXN1Yi1tb2RhbC5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
